import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-book-credit-note-report',
  templateUrl: './book-credit-note-report.component.html',
  styleUrls: ['./book-credit-note-report.component.scss']
})
export class BookCreditNoteReportComponent implements OnInit {
  filterData: any[] = [];
  groupedData: any[] = [];
  currentDate = new Date();
  TotalBillAmt: number = 0;
  TotalCreditNoteAmt: number = 0;
  startDate: string = '';
  endDate: string = '';
  reportType: string = '';
  officerepwise: any;
  booksellerwise:any;
  repName: any;

  constructor(
    private dialogRef: MatDialogRef<BookCreditNoteReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService
  ) {}

  ngOnInit(): void {
    this.startDate = this.data['startDate'];
    this.endDate = this.data['endDate'];
    this.officerepwise = this.data?.office_rep_name || this.data?.officerepwise || '';
    this.booksellerwise = this.data?.booksellerwise || this.data?.booksellerwise || '';
     this.repName = this.data?.rep_name || this.data?.repName || '';
    this.reportType = this.data['reportType'];
    this.getCreditNoteData();
  }

  // ✅ Fetch API Data
  getCreditNoteData() {
    const req = {
      start_crdtnote_date: this.startDate,
      end_crdtnote_date: this.endDate,
      office_rep_name: this.officerepwise,
      rep_name: this.repName,
      bill_no: this.data['bill_no'] || '',
      book_seller_name: this.booksellerwise,
      crdtnote_no: this.data['crdtnote_no'] || '',
      book: this.data['book'] || ''
    };

    this.service.getBookCreditNoteReport(req).subscribe({
      next: (res: any) => {
        this.filterData = res || [];
        this.calculateTotals();
        this.groupDataByOfficeAndRep();
      },
      error: (err) => {
        console.error('Error fetching Book Credit Note data:', err);
      }
    });
  }

  // ✅ Group data by Office Representative and Representative
  groupDataByOfficeAndRep(): void {
    const officeMap = new Map<string, any>();

    this.filterData.forEach((item) => {
      const officeKey = item.office_rep_name || 'Unknown Office';
      const repKey = item.rep_name || 'Unknown Representative';

      // Get or create office group
      if (!officeMap.has(officeKey)) {
        officeMap.set(officeKey, {
          office_rep_name: officeKey,
          representatives: new Map<string, any>(),
          office_bill_total: 0,
          office_credit_total: 0
        });
      }

      const office = officeMap.get(officeKey);

      // Get or create representative group
      if (!office.representatives.has(repKey)) {
        office.representatives.set(repKey, {
          rep_name: repKey,
          records: [],
          rep_bill_total: 0,
          rep_credit_total: 0
        });
      }

      const rep = office.representatives.get(repKey);

      // Add record to representative
      rep.records.push(item);
      
      // Calculate representative totals
      const billAmount = parseFloat(item.bill_amount) || 0;
      const creditAmount = parseFloat(item.crdtnote_total) || 0;
      
      rep.rep_bill_total += billAmount;
      rep.rep_credit_total += creditAmount;

      // Update office totals
      office.office_bill_total += billAmount;
      office.office_credit_total += creditAmount;
    });

    // Convert maps to arrays for template
    this.groupedData = Array.from(officeMap.values()).map(office => ({
      ...office,
      representatives: Array.from(office.representatives.values()),
      office_bill_total: office.office_bill_total.toFixed(2),
      office_credit_total: office.office_credit_total.toFixed(2)
    })).map(office => ({
      ...office,
      representatives: office.representatives.map((rep: any) => ({
        ...rep,
        rep_bill_total: rep.rep_bill_total.toFixed(2),
        rep_credit_total: rep.rep_credit_total.toFixed(2)
      }))
    }));
  }

  // ✅ Calculate Grand Totals
  calculateTotals(): void {
    this.TotalBillAmt = 0;
    this.TotalCreditNoteAmt = 0;

    this.filterData.forEach((item) => {
      this.TotalBillAmt += parseFloat(item.bill_amount) || 0;
      this.TotalCreditNoteAmt += parseFloat(item.crdtnote_total) || 0;
    });

    this.TotalBillAmt = parseFloat(this.TotalBillAmt.toFixed(2));
    this.TotalCreditNoteAmt = parseFloat(this.TotalCreditNoteAmt.toFixed(2));
  }

  // ✅ Print function
printPage4() {
  const printContent = document.getElementById('print-section');
  if (!printContent) return;

  const WindowPrt = window.open('', '', 'width=1400,height=900');

  WindowPrt!.document.write(`
    <html>
    <head>
      <title>Book Credit Note Report</title>

      <style>
        /* ================= PAGE SETUP ================= */
        @page {
          size: A3 landscape;
          margin-top: 10mm;
          margin-bottom: 10mm;
          margin-left: 20mm;
          margin-right: 10mm;
        }

        html, body {
          margin: 0;
          padding: 0;
           border-top: 1px solid black;
          font-family: Arial, sans-serif;
          font-size: 13px;
          color: #000;
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
        }

        /* ============ REPORT OUTER BORDER ============ */
        .print-wrapper {
            
          padding-right: 6px;
        }

        /* ================= TABLE ================= */
        table {
          width: 100%;
          border-collapse: collapse;
          border-spacing: 0;
          table-layout: auto;
          word-wrap: break-word;
        }

        th, td {
          border: 1px solid black;
          padding: 6px 8px;
          vertical-align: middle;
        }

        th {
          background-color: #f1f1f1 !important;
          font-weight: bold;
          text-align: center;
        }

        /* DARK RIGHT BORDER FOR LAST COLUMN */
        table th:last-child,
        table td:last-child {
          border-right: 1px solid black !important;
        }

        /* ================= HEADER ================= */
        thead {
          display: table-header-group !important;
        }

        /* ================= ROW COLORS ================= */
        tr.office-row td {
          background-color: #e6f2ff !important;
          font-weight: bold;
          text-align: center;
        }

        tr.rep-row td {
          font-weight: bold;
        }

        tr.rep-total td {
          background-color: #ffe9b3 !important;
          font-weight: bold;
        }

        tr.office-total td {
          background-color: #ffd6d6 !important;
          font-weight: bold;
        }

        .grand-total-row td {
          background-color: #d9ead3 !important;
          font-weight: bold;
          text-align: right;
        }

        /* INLINE BACKGROUND SUPPORT */
        tr[style*="background-color: #f4b084"] td {
          background-color: #f4b084 !important;
        }

        tr[style*="background-color: #c8753f"] td {
          background-color: #c8753f !important;
        }

        /* ================= PRINT SAFETY ================= */
        tr, td, th {
          page-break-inside: avoid !important;
        }

        tfoot {
          display: table-footer-group !important;
        }

        .noPrint {
          display: none !important;
        }
      </style>
    </head>

    <body>
      <div class="print-wrapper">
        ${printContent.innerHTML}
      </div>
    </body>
    </html>
  `);

  WindowPrt!.document.close();
  WindowPrt!.focus();

  setTimeout(() => {
    WindowPrt!.print();
    WindowPrt!.close();
  }, 500);
}






  // ✅ Export to Excel
  exportExcel(fileName: string): void {
    const element = document.getElementById('print-section');
    if (!element) return;

    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Report');
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  }
}